import { AddSearchClient } from '@components/AppContext'
import { SearchField } from '@components/Search/shared/SearchField'
import { SearchResults } from '@components/Search/SearchResults'
import styles from './styles.module.scss'
import {
  AddSearchClientProps,
  AddSearchUiProps
} from '@components/Search/types'
import { EmptyObject } from 'types/helpers'
import { analytics } from '@helpers/analytics'
import CustomHead from '@components/Head'
import Head from 'next/head'

const isSandboxEnv = process.env.ENVIRONMENT === 'sandbox'

export function Search() {
  let addSearchUI: AddSearchUiProps | EmptyObject = {}
  let addSearchClient: AddSearchClientProps = AddSearchClient

  if (typeof window !== 'undefined') {
    addSearchClient = new window.AddSearchClient(process.env.ADDSEARCH_SITE_KEY)
    addSearchClient.setPaging(1, 40, 'relevance', 'desc')
    addSearchClient.setFuzzyMatch('retry')
    addSearchClient.addFacetField('custom_fields.parent_colour')

    addSearchUI = new window.AddSearchUI(addSearchClient, {
      analyticsCallback: function (addsearchStatsPayload: {
        event: string
        keyword: string
        numberOfResults: number
        action: string
      }) {
        if (typeof window.analytics != 'undefined') {
          const matchesKeywordLength =
            addsearchStatsPayload.keyword?.trim().length > 2
          try {
            if (
              addsearchStatsPayload.action === 'search' &&
              matchesKeywordLength
            ) {
              analytics('Search Results', {
                event: 'View Search Results',
                search_term: addsearchStatsPayload.keyword,
                num_results: addsearchStatsPayload.numberOfResults,
                search_or_click: addsearchStatsPayload.action
              })
            }
            if (addsearchStatsPayload.action === 'click') {
              analytics('Clicked Search Results Item', {
                event: 'Click Search Results',
                search_term: addsearchStatsPayload.keyword,
                num_results: addsearchStatsPayload.numberOfResults,
                search_or_click: addsearchStatsPayload.action
              })
            }
          } catch (err) {
            console.log('error:analyticsCallback', err)
          }
        }
      }
    })
  }

  return (
    <>
      <CustomHead includeNoFollow={true} />
      <Head>
        {!isSandboxEnv && (
          <>
            <script
              src="https://cdn.jsdelivr.net/npm/addsearch-js-client@0.8/dist/addsearch-js-client.min.js"
              defer={true}
            ></script>
            <script
              src="https://cdn.jsdelivr.net/npm/addsearch-search-ui@0.9.0/dist/addsearch-search-ui.min.js"
              defer={true}
            ></script>
            <link
              rel="stylesheet"
              href="https://cdn.jsdelivr.net/npm/addsearch-search-ui@0.8/dist/addsearch-search-ui.min.css"
            />
          </>
        )}
      </Head>
      <div className={styles.SearchResultsPage}>
        <div className={styles.SearchResultsPage__searchField}>
          <SearchField
            uiInstance={addSearchUI}
            containerId="search-field"
            searchAsYouType={true}
          />
        </div>
        <SearchResults
          uiInstance={addSearchUI}
          containerId="addSearchResultsPage"
          client={addSearchClient}
        />
      </div>
    </>
  )
}
